import { render } from "./content-1.vue?vue&type=template&id=99e448b2"
import script from "./content-1.vue?vue&type=script&lang=js"
export * from "./content-1.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__